import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconOffline: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"offline, disconnect, energy"} maskId="square-filled-radius-0-stroke-1-IconOffline"><path fillRule="evenodd" clipRule="evenodd" d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM13.5 11.25L10.5 9.5L6 14.5L10.5 12.75L13.5 14.5L18 9.5L13.5 11.25Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconOffline;
